import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchSettings } from '../../lib/api';

export function useSettings() {
  return useQuery({
    queryKey: queryKeys.settings(),
    queryFn: fetchSettings,
  });
}
